import { safetyMargins, HD, FULL_HD } from '@bedrock-rdk/constants';
import { TERTIARY, makeThemeColor } from '@tornado-rdk/theme';
import { makeDefaultStylingContext } from '../../../tornado/utils/style';
import { middle, SCREEN_HEIGHT, SCREEN_WIDTH } from '../../../tornado/utils/sizes';
import { ICON_TYPE } from '../../../tornado/icon/icon.constants';

export const BRAND_ICON_SIZE = {
  [HD]: 64,
  [FULL_HD]: 72,
};

const ARROW_PADDING_BOTTOM = {
  [HD]: 24,
  [FULL_HD]: 32,
};
const ARROW_SIZE = {
  [HD]: 96,
  [FULL_HD]: 128,
};

const CONTENT_SIDE_MARGIN = {
  [HD]: 300,
  [FULL_HD]: 460,
};

const GRADIENT_HEIGHT = {
  [HD]: 20,
  [FULL_HD]: 40,
};

export const VIEWPORT_OFFSET_PERCENTAGE = 0.95;

export const defaultContext = makeDefaultStylingContext();

export const getInitialStyle = (context = defaultContext) => {
  const { screenSize, colorMode } = context;
  const topY = safetyMargins.vertical[screenSize];
  const scrollWrapperY = topY + ARROW_SIZE[screenSize] + ARROW_PADDING_BOTTOM[screenSize];
  const scrollWrapperWidth = SCREEN_WIDTH[screenSize] - CONTENT_SIDE_MARGIN[screenSize] * 2;
  const scrollWrapperHeight =
    SCREEN_HEIGHT[screenSize] - safetyMargins.vertical[screenSize] - scrollWrapperY - ARROW_SIZE[screenSize];
  const colors = {
    background: makeThemeColor(TERTIARY),
    gradientFill: makeThemeColor(TERTIARY),
    transparent: makeThemeColor(TERTIARY, 0),
  };

  return {
    w: SCREEN_WIDTH[screenSize],
    h: SCREEN_HEIGHT[screenSize],
    Background: {
      rect: true,
      w: SCREEN_WIDTH[screenSize],
      h: SCREEN_HEIGHT[screenSize],
      color: colors.background[colorMode],
    },
    BackButton: {
      x: safetyMargins.horizontal[screenSize],
      y: topY,
    },
    ArrowUp: {
      y: topY,
      mountX: 0.5,
      x: middle,
      visible: false,
      iconData: {
        picto: {
          name: 'ArrowUp',
          type: ICON_TYPE.SIMPLE_ICON,
        },
        viewBox: {
          h: ARROW_SIZE[screenSize],
        },
      },
    },
    BrandIcon: {
      h: BRAND_ICON_SIZE[screenSize],
      y: topY,
      mountX: 0.5,
      x: middle,
    },
    ScrollWrapper: {
      zIndex: 1,
      mountX: 0.5,
      x: middle,
      y: scrollWrapperY,
      w: scrollWrapperWidth,
      h: scrollWrapperHeight,
      color: colors.background[colorMode],
      rect: true,
      clipping: true,
      GradientTop: {
        w: scrollWrapperWidth,
        h: GRADIENT_HEIGHT[screenSize],
        zIndex: 2,
        rect: true,
        mountX: 0.5,
        x: middle,
        colorUl: colors.gradientFill[colorMode],
        colorUr: colors.gradientFill[colorMode],
        colorBr: colors.transparent[colorMode],
        colorBl: colors.transparent[colorMode],
      },
      ScrollContent: {
        zIndex: 1,
        w: scrollWrapperWidth,
        flex: { direction: 'column' },
      },
      GradientBottom: {
        w: scrollWrapperWidth,
        h: GRADIENT_HEIGHT[screenSize],
        zIndex: 2,
        rect: true,
        mountX: 0.5,
        x: middle,
        y: scrollWrapperHeight - GRADIENT_HEIGHT[screenSize],
        colorUr: colors.transparent[colorMode],
        colorUl: colors.transparent[colorMode],
        colorBl: colors.gradientFill[colorMode],
        colorBr: colors.gradientFill[colorMode],
      },
    },
    ArrowDown: {
      mountY: 1,
      y: SCREEN_HEIGHT[screenSize] - safetyMargins.vertical[screenSize],
      mountX: 0.5,
      x: middle,
      visible: false,
      iconData: {
        picto: {
          name: 'ArrowDown',
          type: ICON_TYPE.SIMPLE_ICON,
        },
        viewBox: {
          h: ARROW_SIZE[screenSize],
        },
      },
    },
  };
};

export const gridPadding = {
  left: 224,
};
